import formatIsoDate from '@/services/general/formatIsoDate';
import calculArrondi from '@/services/calcul/calculArrondi';

export default function preparationContratAvantEnvoieBack(contrat, societeActiveId) {
  contrat.intervenants.splice(contrat.intervenants.length - 1, 1);
  contrat.societeId = societeActiveId;
  contrat.dateDebutSignature = formatIsoDate(contrat.dateDebutSignature);
  contrat.dateFinSignature = formatIsoDate(contrat.dateFinSignature);
  contrat.dateDebutEcheance = formatIsoDate(contrat.dateDebutEcheance);
  contrat.dateFinEcheance = formatIsoDate(contrat.dateFinEcheance);
  contrat.datePreavis = formatIsoDate(contrat.datePreavis);
  contrat.dateSignature = formatIsoDate(contrat.dateSignature);
  contrat.dateIndexationReference = formatIsoDate(contrat.dateIndexationReference);
  contrat.dateIndexationActuel = formatIsoDate(contrat.dateIndexationActuel);
  contrat.dateDerniereIndexation = formatIsoDate(contrat.dateDerniereIndexation);
  contrat.montantIndexationReference = calculArrondi(contrat.montantIndexationReference);
  contrat.valeurIndexationReference = calculArrondi(contrat.valeurIndexationReference);
  contrat.valeurIndexationActuel = calculArrondi(contrat.valeurIndexationActuel);
  contrat.loyerAnnuelHt = calculArrondi(contrat.loyerAnnuelHt);
  contrat.loyerAnnuelTva = calculArrondi(contrat.loyerAnnuelTva);
  contrat.loyerAnnuelTtc = calculArrondi(contrat.loyerAnnuelTtc);
  if (contrat.reglesAchat) {
    contrat.reglesAchat.forEach(item => {
      item.dateDebut = formatIsoDate(item.dateDebut);
      if (item.dateFin) item.dateFin = formatIsoDate(item.dateFin);
    });
  }
}
